import { BaseModel } from './base';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export class Opponent extends BaseModel {
    public plate_number: string;
    public vehicle_type: string;
    public manufacturer: string;
    public model: string;
    public submodel: string;
    public comment: string;
    public insurance_company: string;
    public insurance_number: string;
    public green_card_number: string;
    public claim_number: string;
    public policy_holder: string;

    public readonly trans = {
        plate_number: marker('opponent.plate_number'),
        vehicle_type: marker('opponent.vehicle_type'),
        manufacturer: marker('opponent.manufacturer'),
        model: marker('opponent.model'),
        submodel: marker('opponent.submodel'),
        comment: marker('opponent.comment'),
        insurance: marker('opponent.insurance'),
        insurance_number: marker('opponent.insurance_number'),
        green_card_number: marker('opponent.green_card_number'),
        claim_number: marker('opponent.claim_number'),
        policy_holder: marker('opponent.policy_holder')
    };

    constructor(json?: any) {
        super(json);
    }
}
